<div class="upld-wrap">
  <div class="upld-ttl">
    <h4>Upload excel file</h4>
    <button class="cls-dlg-cls" mat-dialog-close="false" mat-button>
      <i class="material-icons">close</i></button>
  </div>
  <mat-card-content>
    <p>First download the excel file, modify and then upload it to bulk update the features, care instructions, size
      guide, composition and RN number for all products.</p>
    <div>
      <mat-hint class="text-danger" align="start"><b>Note :</b></mat-hint>
      <mat-hint align="start">
        <ol>
          <li>If you are uploading multiple "Features" and "Care_Instruction", make sure you provided them in multiple
            rows.</li>
          <li>"Size_Name" should be available and matched with the product's available size name.</li>
          <li>"Unit" will always be in "Inches(in)" no matter what you provide in excel.</li>
          <li>"Width", "Length" and "Sleeve_Length" should be in number or decimal.</li>
          <li>If you are uploading multiple "Recommended_Product_SKU", make sure you provided them in multiple rows.</li>
          <li>
            "Made_In", "Composition", "RN", "Bestseller", "Enable_Sizing_Label", "Enable_Embroidery" for these columns,
            provide values only in first row of each product as there will be only one value for each product.
          </li>
          <li>
            If you are uploading multiple "Composition", make sure that you provide the values in comma seperated format
            (like cotton, polyester, teracotta) and maximum 3 value are allowed.
          </li>
          <li>For "Bestseller", "Enable_Sizing_Label", "Enable_Embroidery" values should be "Yes" or "No".</li>
        </ol>
      </mat-hint>
    </div>
    <input id="myInput" #myInput type="file" (change)="fileChangeEvent($event)"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
    <div class="file-upload">
      <button matTooltip="Upload xlsx" mat-mini-fab color="primary" class="upload-btn" (click)="myInput.click()">
        <mat-icon>attach_file</mat-icon>
      </button>
      {{fileName || "No file uploaded yet."}}
    </div>
    <br />
    <div class="hint">
      <mat-hint align="start">*Only .xlsx file type allowed</mat-hint>
    </div>
    <div class="hint">
      <mat-hint align="start">*Size should be less than 10 MB</mat-hint>
    </div>
    <div class="text-danger">
      {{errorMessage}}
    </div>
  </mat-card-content>
  <mat-dialog-actions class="mt-act">
    <button [disabled]="!fileUploaded" mat-raised-button (click)="fn_UploadFile()" class="sbmt-btn">Submit</button>
  </mat-dialog-actions>
</div>